<div class="filter-row">
    <div class="filter-card" [class.filter-card-active]="showFilterOptions" (click)="toggleFilterOptions()"
        tabindex="0" role="button">
        <img src="/assets/icons/results/filter.svg" alt="filter" />
        <span *ngIf="!showFilterOptions && filterBadgeCount > 0" class="filter-badge-red">
            <img src="/assets/icons/find-job/filter-green-dot.svg" alt="filter-dot" />
        </span>
        <p [class]="`${filterBadgeCount == 0 || showFilterOptions ? 'filter-text' : ''}`">Filter Jobs</p>
    </div>

    <div class="dropdown-container">
        <label for="sortby_dropdown" class="sort-by-text">Sort By:</label>
        <select id="sortby_dropdown" class="dropdown" [value]="sortSelected" (change)="sortResults($event)">
            @for (sortBy of sortByOptions; track $index) {
            <option [value]="sortBy.value">{{ sortBy.label }}</option>
            }
        </select>
        <span class="dropdown-arrow">
            <img src="/assets/icons/results/dropdown-arrow.svg" alt="dropdown" />
        </span>
    </div>

    <p *ngIf="!showFilterOptions" class="matched">
        Jobs Matched: <span class="matched-count">{{ jobListData.length }}</span>
    </p>
</div>

<div [hidden]="!showFilterOptions" class="filter-options-div show-filter"
    [attr.tabindex]="showFilterOptions ? '0' : '-1'">
    <form>
        <!-- <div class="area-header"> -->
        <div class="filter-actions">
            <p class="clear-text" (click)="clearFilters()">
                Reset Filters
            </p>
            <button mat-flat-button type="button" class="apply-btn" (click)="applyFilters()">
                Apply
            </button>
        </div>
        <!-- </div> -->
        <div class="filter-column margin-1">
            <div class="arears-div row2">
                <div class="filter-section role-section">
                    <div class="match-div">
                        <p class="title">Role Type</p>
                    </div>
                    <div class="area-option-div">
                            <mat-radio-group [(ngModel)]="isInternship"  name="jobTypeRadio" class="job-radio-group">
                                <div class="permanent-row">
                                    <mat-radio-button [disableRipple]="true" class="job-option" [value]="false">
                                            Permanent
                                    </mat-radio-button>
                                    @if(!isInternship) {
                                           <div class="roleType-options">
                                                @for (item of jobTypes; track $index) {
                                                <button type="button" class="areas" [class]="selectedType.includes(item) ? 'area-active' : ''"
                                                    (click)="selectType(item)">
                                                    <p>{{ item | underscoreToLower }}</p>
                                                </button>
                                                }
                                            </div>
                                    }
                                </div>
                                  
                                 <mat-radio-button [disableRipple]="true" class="job-option" [value]="true">
                                    Internship
                                </mat-radio-button>
                            </mat-radio-group>
                    </div>
                </div>

                <div class="filter-section location-section location-div" [ngClass]="isInternship ? 'margin-top-4' : 'margin-1 padding-top-2'">
                    <div class="location-div">
                        <p class="title">Location</p>
                        <p class="user-location-text">
                            {{ userData.futureLocation || 'User location not available' }}
                            <a class="location-change-link" routerLink="/profile">
                                Change
                            </a>
                        </p>
                    </div>

                    <div class="area-option-div">
                        @for (item of jobLocation; track $index) {
                        <button type="button" class="areas"
                            [class]="selectedLocation.includes(item) ? 'area-active' : ''"
                            (click)="selectLocation(item)">
                            <p>{{ item | underscoreToLower }}</p>
                        </button>
                        }

                    </div>

                </div>
            </div>
            <div class="areas-divider" aria-hidden="true"></div>
            <div class="arears-div row2">
                <div class="filter-section education-section location-div">
                    <div class="match-div ">
                        <p class="title">Minimum Education</p>
                    </div>

                    <div class="education-div">
                        <div class="education-level">
                            @for (item of jobEducationLevels; track $index) {
                            <img [src]="`/assets/icons/find-job/degree-icon${$index <= educationLevelIndex() ? '-filled' : ''}.svg`"
                                alt="degree level" (click)="setEducationLevel(item.key)" />
                            }
                        </div>
                        <p class="education-level-text">
                            {{ educationLevelLabel() }}
                        </p>
                    </div>
                </div>

                <div class="filter-section additional-section location-div location-margin" [ngClass]="isInternship ? 'margin-top-4' : 'margin-1 padding-top-2'">
                    <div class="match-div">
                        <p class="title">Additional Settings</p>
                    </div>
                    <div class="sliders">
                        <mat-slide-toggle [disabled]="!career_goal" [(ngModel)]="is_related_to_career_goal"  name="is_career_goal_set" [disableRipple]="true"
                            class="small-toggle" [attr.aria-labelledby]="'Related to career goal'">
                            <span id="related_to_career_goal" class="toggle-label">
                              {{  'Related to your career goal' }}
                            </span>
                        </mat-slide-toggle>
                        <div class="toggle-label career-goal" (click)="navigateToCareerGoal()" >
                            <p class="career-goal-text">{{ career_goal ? 'Change career goal' : 'Set a career goal' }}</p>
                        </div>
                        <mat-slide-toggle [(ngModel)]="is_bookmarked" name="is_bookmarked" [disableRipple]="true"
                            class="small-toggle" [attr.aria-labelledby]="'Bookmarked jobs first'">
                            <span id="bookmarkedJobs" class="toggle-label">Bookmarked jobs first</span>
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>